// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/**\n * COODE Header Colors\n */\n.email-template__form__tag-list {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  border: 1px #ADADAD solid;\n  border-radius: 4px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
